import { render, staticRenderFns } from "./AtencionProcedimientos.vue?vue&type=template&id=57bb1562"
import script from "./AtencionProcedimientos.vue?vue&type=script&lang=js"
export * from "./AtencionProcedimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports